import { render, staticRenderFns } from "./notificationModal.vue?vue&type=template&id=08610b4d&scoped=true"
import script from "./notificationModal.vue?vue&type=script&lang=js"
export * from "./notificationModal.vue?vue&type=script&lang=js"
import style0 from "./notificationModal.vue?vue&type=style&index=0&id=08610b4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08610b4d",
  null
  
)

export default component.exports